//  External
import { Component, OnInit, Input, Renderer2, ElementRef} from '@angular/core';

// Internal

@Component({
    selector: 'empty-state',
    templateUrl: './empty-state.component.html'
})
export class EmptyStateComponent implements OnInit {

    @Input() type: string = 'page';
    @Input() maxWidth: string = '420px';
    @Input() imgMaxWidth: string = '100%';
    @Input() image: string;
    @Input() icon: string;
    @Input() title: string;
    @Input() details: string;

    @Input() idTimestamp: string;

    constructor(private renderer: Renderer2, private el: ElementRef) { }

    ngOnInit() {
        this.renderer.addClass(this.el.nativeElement, 'empty-state');
        this.renderer.addClass(this.el.nativeElement, this.type);
    }

}
